<svelte:options customElement="hb-cookie-law-banner" />

<script lang="ts">
  /**
   * Svelte Video Gallery WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import { dictionary } from "./libs/i18n";
  import { LanguageTranslator } from "wc-js-utils";
  import type { Component } from "./types/webcomponent.type";

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  // let localDictionary = dictionary["en"];
  // let translator.translateWord: (e: string) => string;

  let {
    id = "",
    cookielawuri4more = "",
    capabilities = undefined,
    allowdecline = "no",
    i18nlang,
  }: Component = $props();

  let isSet: boolean = $state(false);
  let translator: LanguageTranslator = $state(
    new LanguageTranslator({ dictionary, lang: i18nlang }),
  );

  $effect(() => {
    if (typeof capabilities === "string") {
      try {
        capabilities = JSON.parse(capabilities as unknown as string);
      } catch (err) {}
    }

    isSet = localStorage.getItem(localStorageItem) ? true : false;
    if (allowdecline !== "yes") allowdecline = "no";
    // if (!i18nlang || !dictionary[i18nlang]) {
    // 	const autolang = navigator?.languages ? navigator.languages[0]?.split("-")[0]?.toLowerCase() : null;
    // 	if (autolang && dictionary[autolang]) {
    // 		i18nlang = autolang;
    // 	} else {
    // 		i18nlang = "en";
    // 	}
    // 	localDictionary = dictionary[i18nlang];
    // } else {
    // 	localDictionary = dictionary[i18nlang];
    // }

    if (
      translator &&
      i18nlang &&
      translator.lang &&
      translator.lang !== i18nlang
    ) {
      translator = new LanguageTranslator({ dictionary, lang: i18nlang });
    }
    // translator.translateWord = (w) => {
    // 	return localDictionary[w] || dictionary["en"][w] || "";
    // };
  });

  const localStorageItem = "cookielaw";
  function dispatchChoose(accepted: boolean) {
    console.info("accept cookie law");
    const name = "acceptCookieLaw";
    const detail = { accepted };
    const choose = accepted ? "yes" : "no";
    localStorage.setItem(localStorageItem, choose);
    isSet = true;
    dispatch(name, detail);
  }
</script>

<div
  id="cookiealert"
  class="hb-cookie-law notification is-dark is-radiusless mb-0 {isSet ? '' : 'is-visible'}"
  role="alert"
>
  <div class="columns is-mobile is-vcentered is-multiline mb-0">
    <div class="column is-12-mobile is-8-tablet">
      <h3 class="title is-5 mb-2">
        <slot name="title">
          {translator.translateWord("cookieLawTitle")}
        </slot>
      </h3>
      <div class="content is-size-6 mb-0">
        <slot name="text">
          {translator.translateWord("basicCookieLaw")}
        </slot>
      </div>
    </div>
    <div
      class="column is-12-mobile is-4-tablet is-flex is-flex-wrap-wrap is-justify-content-flex-end is-align-items-center is-gap-2"
    >
      {#if cookielawuri4more !== "no"}
        <a
          class="is-size-6 has-text-weight-semibold"
          href={cookielawuri4more || "https://wikipedia.org/wiki/HTTP_cookie"}
          target="_blank"
          rel="noopener noreferrer">{translator.translateWord("learnmore")}</a
        >
      {/if}
      {#if allowdecline === "yes"}
        <button
          type="button"
          class="button is-light is-small"
          onclick={() => dispatchChoose(false)}
          >{translator.translateWord("decline")}</button
        >
      {/if}
      <button
        type="button"
        class="button is-primary is-small"
        onclick={() => dispatchChoose(true)}
        >{translator.translateWord("accept")}</button
      >
    </div>
  </div>
</div>

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
